<template>
  <main class="discount-detail">
    <vue-headful
      v-if="current"
      :description="description"
      :title="'Enjoj | ' + current.title"
      :image="current.image_url"
    />
    <ec-page-heading
      :paragraph="paragraph"
      :sub-title="subTitle"
      :title="pageTitle"
      class="intro-text wrapper pt-5 pb-5"
    />
    <div class="loading mt-5" v-loading="isLoading && currentIndex !== -1" >
      <div v-if="current" class="container">

        <div class="row">
          <div class="navigator custom-carousel__buttons col-12 d-flex mb-4">
            <button class="nav prev ml-auto d-block d-lg-none" @click="nextPrevPage(-1)"></button>
            <button class="nav next ml-4 d-block d-lg-none" @click="nextPrevPage(1)"></button>
          </div>
        </div>

        <div class="row mb-4 mb-lg-5">
          <header class="discount-detail__title d-flex col-12 col-lg-6">
            <div class="icon text-white text-center p-2 mr-4" :class="'bg-category-' + current.branche">
              <i :class="brancheIcon(current.branche)" />
            </div>
            <div class="text">
              <small class="d-block mb-2 font-patrick-hand">{{ current.surrounding.name }}</small>
              <h2>{{ current.title }}</h2>
            </div>
          </header>
          <div class="navigator custom-carousel__buttons d-flex align-items-center col-6">
            <button class="nav prev ml-auto d-none d-lg-block" @click="nextPrevPage(-1)"></button>
            <button class="nav next ml-4 d-none d-lg-block" @click="nextPrevPage(1)"></button>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-8">
            <router-view :discount="current" :pdf="pdf" />
            <div class="discount-detail__footer my-5 py-3">
              <router-link to="/aanbiedingen" >
                <i class="enjoj-arrow-back mr-2" />
                <span class="font-montserrat">Aanbiedingen overzicht</span>
              </router-link>
            </div>
          </div>

          <div class="col-12 col-lg-4">
            <div class="discount-detail-list__title mb-4">
              <small class="d-block font-patrick-hand mb-1">Dichtstbijzijnde</small>
              <h2>Aanbiedingen</h2>
            </div>
            <ul class="discount-detail-list__content px-4 py-2 mb-5">
              <li v-for="(discount, index) in nearestDiscounts" :key="index" class="d-flex align-items-center py-3">
                <h3 class="w-60">{{ discount.title }}</h3>
                <button class="discount-btn text-white ml-auto" @click="goByList(index)">Bekijk actie</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p v-if="currentIndex === -1 || !current" class="text-center p-5"><i>Helaas, er is geen aanbieding gevonden.</i></p>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import ecPageHeading from '@/components/General/PageHeading'
import pdfvuer from 'pdfvuer'
import Branche from '@/mixins/Branche'
import Discounts from '@/mixins/Discounts'
import Location from '@/mixins/Location'

export default {
  name: 'DiscountDetail',
  mixins: [Discounts, Location, Branche],
  components: {
    ecPageHeading
  },
  computed: {
    ...mapState([
      'surroundingLoaded',
      'discounts'
    ]),
    current () {
      return this.discounts[this.currentIndex]
    },
    description () {
      if (this.current.customData) {
        return this.current.description
      }
      return null
    },
    nearestDiscounts () {
      return this.discounts.slice(0, 4)
    },
    pageTitle () {
      return 'Aanbiedingen'
    },
    paragraph () {
      return 'Klik op de aanbieding om de actie of actiefolder te bekijken'
    },
    subTitle () {
      return 'Alle lokale acties in één overzicht!'
    }
  },
  data () {
    return {
      currentIndex: 0,
      isLoading: false,
      pdf: {
        data: undefined,
        loadedData: null,
        loading: true,
        page: 1,
        pages: 0
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === null) {
      next(vm => {
        vm.getSiteData()
      })
    } else {
      next(vm => {
        if (vm.surroundingLoaded) {
          vm.setData()
        }
      })
    }
  },
  methods: {
    goRoute () {
      const discount = this.current
      const { info } = discount
      if (discount.customData) {
        this.$router.push({ name: 'discountCustom', params: { discount: `${this.kebab(info.title)}-${info.id}`, slug: `${this.kebab(discount.title)}-${discount.customData.id}` } })
      } else {
        this.$router.push({ name: 'discountPdf', params: { discount: `${this.kebab(info.title)}-${info.id}` } })
      }
    },
    goByList (i) {
      this.currentIndex = i
      this.goRoute()
    },
    nextPrevPage (input) {
      if (input === -1) {
        if (this.currentIndex + input > 0) {
          this.currentIndex += input
        } else {
          this.currentIndex = this.discounts.length - 1
        }
      } else {
        if (this.currentIndex + input < this.discounts.length) {
          this.currentIndex += input
        } else {
          this.currentIndex = 0
        }
      }
      this.goRoute()
      this.loadPdf()
    },
    loadPdf () {
      if (this.current.pdfData) {
        const url = this.current.pdfData.pdf_url
        this.pdf.loading = false
        this.pdf.page = 1
        this.pdf.beforePage = 1
        this.pdf.data = pdfvuer.createLoadingTask(url)
        this.pdf.data.then(pdf => {
          this.pdf.pages = pdf.numPages
          this.pdf.loading = true
          this.pdf.loadedData = pdf
        })
      }
    },
    setData () {
      this.isLoading = true
      if (this.discounts.length === 0) {
        this.getDiscounts().then(() => {
          this.getDiscountIndex(this.$route.params, this.discounts).then(index => {
            this.currentIndex = index
            this.loadPdf()
            this.isLoading = false
          })
        }).catch(err => console.log(err))
      } else {
        this.getDiscountIndex(this.$route.params, this.discounts).then(index => {
          this.currentIndex = index
          this.loadPdf()
          this.isLoading = false
        })
      }
    }
  },
  watch: {
    surroundingLoaded (condition) {
      if (condition) {
        this.$store.commit('setIsLoading', false)
        this.setData()
      }
    }
  }
}
</script>

<style lang="scss">
.loading {
  min-height: 200px;
}
</style>
